export default __webpack_public_path__ + "static/media/plus-icon.d064e39d.svg";